module.exports = __webpack_public_path__ + "static/media/Character5.f73d28c4.png";